import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/lib/i18n";

const TEL = "+77000222674";
const DISPLAY = "+7 700 022 26 74";

export const DirectorPhone = ({ id }) => {
  const { t } = useLang();
  return (
    <div data-testid={`${id}-director-phone`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
      <a href={`tel:${TEL}`} aria-label={t.req.call} data-testid={`${id}-director-phone-link`} className={`inline-flex items-center gap-2 font-display text-xl text-[var(--text)] hover:text-[var(--gold)] transition-colors`}>
        <Phone className="w-4 h-4 text-[var(--gold)]" /> {DISPLAY}
      </a>
      <a href={`https://wa.me/${TEL.slice(1)}`} target="_blank" rel="noopener noreferrer" data-testid={`${id}-director-whatsapp-link`} className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] text-[#0A0D14] text-xs font-semibold px-3 py-1.5 hover:brightness-110 transition-[filter]">
        <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
      </a>
      </div>
    </div>
  );
};
